<template>
  <div id="app">
    <router-view/>
    <c-error-dialog :show="hasError"/>
    <component :is="apiLogs"/>
  </div>
</template>

<script>
import CErrorDialog from '@/components/CErrorDialog'
const CApiLogs = () => import(/* webpackChunkName: "devtools" */ '@/components/CApiLogs')

export default {
  name: 'App',
  components: {
    CErrorDialog
  },
  computed: {
    hasError () {
      return this.getters['api/hasError']
    },
    apiLogs () {
      return process.env.VUE_APP_API_LOG ? CApiLogs : null
    }
  }
}
</script>
